import { Box, Button, ButtonProps, IconButton } from '@chakra-ui/react'
import ExternalLink from 'components/links/ExternalLink'
import WhatsApp from 'components/svg/WhatsApp'
import { Label } from 'components/typography'
import {
  MEDLEVE_WHATSAPP_LINK,
  MEDLEVE_WHATSAPP_NUMBER,
  MEDLEVE_WHATSAPP_NUMBER_MASKED,
  OMENS_WHATSAPP_LINK,
  OMENS_WHATSAPP_NUMBER,
  OMENS_WHATSAPP_NUMBER_MASKED
} from 'constants/omensSupportContact'
import { useIsMedlevePage } from 'hooks/helpers/useIsMedlevePage'
import { FC } from 'react'
import { getCookies } from 'utils/cookieHelpers'

interface WhatsAppButtonProps extends ButtonProps {
  withLabel?: boolean
  withPhoneNumber?: boolean
  iconColor?: string
  btnBg?: string
  hover?: string
  iconSize?: string
  customLabel?: string
  whatsappLink?: string
}
// TODO: refactor this component considering new website design

const WhatsappButton: FC<WhatsAppButtonProps> = ({
  withLabel = false,
  withPhoneNumber = false,
  btnBg,
  iconColor,
  hover,
  iconSize,
  customLabel,
  whatsappLink = OMENS_WHATSAPP_LINK,
  ...rest
}) => {
  const isMedleve = useIsMedlevePage()

  if (customLabel) {
    return (
      <ExternalLink href={isMedleve ? MEDLEVE_WHATSAPP_LINK : whatsappLink}>
        <Button
          bg={btnBg || 'alabaster'}
          leftIcon={<WhatsApp fontSize={iconSize} {...(iconColor && { color: iconColor })} />}
          w="100%"
          {...rest}
        >
          <Label color={iconColor}>{customLabel}</Label>
        </Button>
      </ExternalLink>
    )
  }
  return withLabel ? (
    <ExternalLink href={isMedleve ? MEDLEVE_WHATSAPP_LINK : whatsappLink}>
      <Button
        bg="green.150"
        _hover={{ bg: hover || 'green.200' }}
        rightIcon={<WhatsApp color={iconColor || 'black.100'} />}
        color="black"
        fontWeight="500"
        minH="48px"
        {...rest}
      >
        <Box pl="4px">Conversar no WhatsApp</Box>
      </Button>
    </ExternalLink>
  ) : withPhoneNumber ? (
    <ExternalLink href={isMedleve ? MEDLEVE_WHATSAPP_LINK : whatsappLink}>
      <Button
        bg="green.150"
        _hover={{ bg: 'green.200' }}
        leftIcon={<WhatsApp color={iconColor || 'black.100'} />}
        color="white"
        fontWeight="500"
        fontSize="lg"
        minH="48px"
        {...rest}
      >
        {isMedleve ? MEDLEVE_WHATSAPP_NUMBER_MASKED : OMENS_WHATSAPP_NUMBER_MASKED}
      </Button>
    </ExternalLink>
  ) : (
    <ExternalLink href={isMedleve ? MEDLEVE_WHATSAPP_LINK : whatsappLink}>
      <IconButton
        variant="ghost"
        bg={btnBg}
        shadow="none"
        aria-label="whatsapp"
        icon={<WhatsApp fontSize={iconSize} {...(iconColor && { color: iconColor })} />}
        minH="48px"
        minW="48px"
        {...rest}
      />
    </ExternalLink>
  )
}

export default WhatsappButton
